import Shape from './../components/Shape';

const drawTopTextRing = (x, y, r, onePartSize, rotation, id = null) => {
    const ring = Shape.create(id);
    for (let angle = 0; angle < Math.PI * 2; angle += onePartSize) {
        const a = angle + rotation + (onePartSize / 2);
        if (angle === 0) {
            ring.moveTo(x + Math.sin(a) * r, y + Math.cos(a) * r);
        } else {
            ring.arc(r, r, 0, 1, 1, x + Math.sin(a) * r, y + Math.cos(a) * r);
        }
    }
    return ring.element();
};

export default drawTopTextRing;
